import { Users, ClipboardCheck, Tablets, Package } from "lucide-react";

const items = [
  { icon: Users, title: "New & ongoing users" },
  { icon: ClipboardCheck, title: "NHS funded service" },
  { icon: Tablets, title: "Tablets only" },
  { icon: Package, title: "1 to 3 day delivery" },
];

const TrustStrip = () => {
  return (
    <div className="py-3.5 px-4 border-b border-border/40">
      <div className="max-w-sm lg:max-w-6xl xl:max-w-7xl mx-auto grid grid-cols-4 gap-2 lg:flex lg:justify-center lg:gap-16">
        {items.map((item) => (
          <div key={item.title} className="flex flex-col items-center gap-1 flex-1 min-w-0">
            <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-coral/15 flex items-center justify-center">
              <item.icon className="w-4 h-4 lg:w-5 lg:h-5 text-coral" />
            </div>
            <span className="text-[9px] lg:text-xs text-navy font-medium text-center leading-tight">{item.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustStrip;
